export default __webpack_public_path__ + "static/media/lock.0cc0c017.svg";